// App.js

import React from 'react';
import Calculator from './calculator';

function App() {
  return (
    <div className="App">
      <Calculator />
    </div>
  );
}

export default App;
